export default __webpack_public_path__ + "static/media/bg.5ea308d7.svg";